import { API_CONFIG } from '../lib/apiConfig';
import { parseCsv } from '../lib/csv';
import { createCsvStatsHook } from '../lib/hookFactories';
import { GrowthCurves, GrowthCurvePoint } from '../lib/types';

// Column names in the growth_curves CSVs all share a `*-growth_rate-x-x-x-x` suffix.
const COL_MEAN = 'mean-growth_rate-x-x-x-x';
const COL_STD = 'std-growth_rate-x-x-x-x';
const COL_P5 = 'pct5-growth_rate-x-x-x-x';
const COL_P95 = 'pct95-growth_rate-x-x-x-x';

const parseGrowthCurves = (text: string): GrowthCurves => {
  const points: GrowthCurvePoint[] = parseCsv(text)
    .map(row => ({
      year: Number(row['year']),
      mean: Number(row[COL_MEAN]),
      std: Number(row[COL_STD]),
      p5: Number(row[COL_P5]),
      p95: Number(row[COL_P95]),
    }))
    .filter(p =>
      Number.isFinite(p.year) &&
      Number.isFinite(p.mean) &&
      Number.isFinite(p.p5) &&
      Number.isFinite(p.p95),
    )
    .sort((a, b) => a.year - b.year);
  return { points };
};

/**
 * Fetches the projected growth-rate trajectory for the supply shed defined
 * by (millCode, driveTime). CSV lives at
 * sfi/growth_curves/growth_curves_100m_global_stats_{mill}_{driveTime}min.csv.
 */
export const useGrowthCurves = createCsvStatsHook({
  path: API_CONFIG.s3.paths.growthCurves,
  parse: parseGrowthCurves,
  errorPrefix: 'Failed to load growth curves',
});
